import IconFooterLogo from './IconFooterLogo';

export default IconFooterLogo;
